// Cart Height
(function () {
  const CART_ROOT_SELECTOR = "cart-element.cart--root";

  function getSummaryEl(cartRoot) {
    return (
      cartRoot.querySelector(".cart--summary") ||
      cartRoot.querySelector(".cart--footer")
    );
  }

  function updateSummaryHeight(cartRoot) {
    if (!cartRoot) return;
    const summaryEl = getSummaryEl(cartRoot);
    if (!summaryEl) return;

    const h = Math.ceil(summaryEl.getBoundingClientRect().height);
    cartRoot.style.setProperty("--summary-height", `${h}px`);
  }

  function wire(cartRoot) {
    if (!cartRoot || cartRoot.__cuSummaryHeightWired) return;
    cartRoot.__cuSummaryHeightWired = true;

    updateSummaryHeight(cartRoot);

    const summaryEl = getSummaryEl(cartRoot);

    if (summaryEl && "ResizeObserver" in window) {
      const ro = new ResizeObserver(() => updateSummaryHeight(cartRoot));
      ro.observe(summaryEl);
      cartRoot.__cuSummaryHeightRO = ro;
    }

    window.addEventListener(
      "resize",
      () => updateSummaryHeight(cartRoot),
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll(CART_ROOT_SELECTOR).forEach((root) => {
      wire(root);
      updateSummaryHeight(root);
    });
  }

  document.addEventListener("DOMContentLoaded", boot);

  document.addEventListener("cart:updated", boot);
  document.addEventListener("cart:refresh", boot);

  document.addEventListener("click", () => setTimeout(boot, 50), { passive: true });
})();
